import React from 'react'
import { Radio } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from '../../../../../store/reducers/assignment.reducer'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'

export const REVIEW_FILTERS = {
    ALL: 'ALL',
    REVIEWED: 'REVIEWED',
    UNREVIEWED: 'UNREVIEWED',
}

const ReviewFilters = () => {
    const reviewFilter = useSelector(assignmentSelectors.reviewFilter)
    const dispatch = useDispatch()

    const handleChange = event => dispatch(actions.setReviewFilter(event.target.value))

    return (
        <Radio.Group onChange={handleChange} value={reviewFilter}>
            <Radio value={REVIEW_FILTERS.ALL}>All</Radio>
            <Radio value={REVIEW_FILTERS.REVIEWED}>Reviewed</Radio>
            <Radio value={REVIEW_FILTERS.UNREVIEWED}>Unreviewed</Radio>
        </Radio.Group>
    )
}

export default ReviewFilters
